import { Box, Button, Paper, Typography } from '@mui/material';
import type React from 'react';

interface Props {
  onNext: () => void;
}

const ProcurementStep1Welcome: React.FC<Props> = ({ onNext }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, maxWidth: 800, mx: 'auto' }}>
      <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
        Welcome to the Procurement Ecosystem
      </Typography>
      <Typography variant="body1">
        Your organization is now equipped with the advanced AI-driven procurement and evaluation
        suite. BIDLOGIQ's Procurement module helps you automate compliance checks, detect
        contradictions in supplier bids, and construct objective, mathematically sound evaluation
        rubrics.
      </Typography>

      <Paper
        sx={{ p: 3, bgcolor: 'primary.light', color: 'primary.contrastText', borderRadius: 2 }}
      >
        <Typography variant="h6" gutterBottom>
          What to Expect
        </Typography>
        <Typography variant="body2">
          - <strong>Automated RFP Extraction:</strong> Upload your procurement documents and let AI
          automatically extract scope, details, and evaluation rubrics.
          <br />- <strong>Smart Clarifications:</strong> Effortlessly manage supplier Q&A with
          AI-generated responses powered by your organizational knowledge base.
          <br />- <strong>Compliance & Triage:</strong> Let AI handle Pass/Fail compliance and
          semantic contradiction checks before human assessment.
          <br />- <strong>Interactive Scorecards:</strong> Side-by-side bid reading and scoring.
          <br />- <strong>Consensus Reporting:</strong> Automatically draft audit-ready
          justification reports.
        </Typography>
      </Paper>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
        <Button variant="contained" color="primary" onClick={onNext} size="large">
          Next: How it Works
        </Button>
      </Box>
    </Box>
  );
};

export default ProcurementStep1Welcome;
